export { default } from './app.component';
